import Vue from 'vue'
import './plugins/vuetify'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'
import VueParticles from 'vue-particles'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import ProductZoomer from 'vue-product-zoomer'
import {library} from '@fortawesome/fontawesome-svg-core'
import {
    faBriefcase,
    faBuilding,
    faCaretRight,
    faCheck,
    faCheckSquare,
    faEnvelopeOpen,
    faHeart,
    faMapMarkerAlt,
    faPhone,
    faSearch,
    faShoppingCart,
    faSortDown,
    faThumbsUp,
    faTimes,
    faWallet,
    faCalendar,
    faUsers
} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import VueGeolocation from 'vue-browser-geolocation';
import * as VueGoogleMaps from 'vue2-google-maps'
import {StripeCheckout} from 'vue-stripe'
import VModal from 'vue-js-modal'

library.add(faCheck, faTimes, faSearch, faPhone, faEnvelopeOpen, faShoppingCart, faSortDown, faCheckSquare, faMapMarkerAlt, faThumbsUp, faWallet, faHeart, faBriefcase, faBuilding, faCaretRight, faCalendar, faUsers);
Vue.component('stripe-checkout', StripeCheckout);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.use(VueGeolocation);
Vue.use(ProductZoomer);
Vue.use(BootstrapVue);
Vue.use(VueParticles);
Vue.use(VModal)
Vue.config.productionTip = false;
Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyAVRjRduURfENE6crk3ZmP6YtbYV3sGkYc',
        libraries: 'places',
        v: '3.exp',
    },
    installComponents: true,
});

new Vue({
    router,
    store,
    render: function (h) {
        return h(App)
    }
}).$mount('#app');
